<template>
  <w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
    <el-tab-pane label="VM" name="vm">
      <el-radio-group v-model="selectTypeForVm">
        <el-radio :label="'perf'">성능 정보</el-radio>
        <el-radio :label="'config'">구성 정보</el-radio>
      </el-radio-group>
      <w-vm-perf-table v-if="selectTypeForVm === 'perf' && activeTab === 'vm'" :active="active && activeTab === 'vm'"></w-vm-perf-table>
      <w-vm-config-table v-if="selectTypeForVm === 'config' && activeTab === 'vm'" :active="active && activeTab === 'vm'"></w-vm-config-table>
    </el-tab-pane>
  </w-tool-tabs>
</template>

<script>
import WVmPerfTable from '@/views/performance/components/virtual/VmPerfTable';
import WVmConfigTable from '@/views/virtual/performance/group/config/components/VmConfigTable';

export default {
  name: 'WHostListView',
  components: {
    WVmPerfTable,
    WVmConfigTable,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      activeTab: 'vm',
      selectTypeForVm: 'perf',

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/listview/host/index.vue